module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editType == 'examine') ? _c('el-form', {
    ref: "examineForm",
    staticClass: "all-form",
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "model": _vm.examineForm,
      "rules": _vm.examineRules,
      "label-width": "110px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('审批状态'),
      "prop": "checkRes"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.Language('审批状态'),
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.examineForm.checkRes),
      callback: function($$v) {
        _vm.$set(_vm.examineForm, "checkRes", $$v)
      },
      expression: "examineForm.checkRes"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.Language('通过'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.Language('不通过'),
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.Language(_vm.examineForm.checkRes == 2 ? '不通过原因' : '审批内容'),
      "prop": "checkRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": _vm.examineForm.checkRes == 2 ? '请输入不通过原因' : '请输入审批内容',
      "rows": 4
    },
    model: {
      value: (_vm.examineForm.checkRemark),
      callback: function($$v) {
        _vm.$set(_vm.examineForm, "checkRemark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "examineForm.checkRemark"
    }
  })], 1), _vm._v(" "), (_vm.editType == 'examine') ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleExamineFn
    }
  }, [_vm._v(_vm._s(_vm.Language('提交审批')))])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editType == 'return') ? _c('ReturnVisit', {
    attrs: {
      "returnId": _vm.returnId
    },
    on: {
      "closePageView": _vm.closePageView
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "sForm",
    staticClass: "all-form",
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "model": _vm.sForm,
      "rules": _vm.rules,
      "label-width": "110px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "prop": "title",
      "label": _vm.Language('标题')
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.Language('请输入标题'),
      "maxlength": "50",
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    model: {
      value: (_vm.sForm.title),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "sForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block",
      "width": "50%",
      "margin-right": "-5px"
    },
    attrs: {
      "prop": "orderTypeCode",
      "label": _vm.Language('工单类型')
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.Language('请选择工单类型'),
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.orderTypeCodeChangeFn
    },
    model: {
      value: (_vm.sForm.orderTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "orderTypeCode", $$v)
      },
      expression: "sForm.orderTypeCode"
    }
  }, _vm._l((_vm.optionList['orderType']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block",
      "width": "50%"
    },
    attrs: {
      "prop": "formId",
      "label": _vm.Language('表单名称')
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择表单名称",
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.sForm.formId),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "formId", $$v)
      },
      expression: "sForm.formId"
    }
  }, _vm._l((_vm.orderFormOption.filter(function (item) {
    return item.isValid == 1
  })), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.formColumnList.filter(function (item) {
    return item.fieldName != 'title' && item.fieldName != 'orderTypeCode' && item.fieldName != 'formId' && item.fieldName != 'cusId' && item.fieldName != 'isReceiveOverTime' && item.fieldName != 'sourceId'
  })), function(item, index) {
    return _c('el-form-item', {
      key: index,
      staticClass: "mb15",
      style: (_vm.getStyle(item)),
      attrs: {
        "prop": item.fieldName,
        "rules": item.isRequired == 1 ? _vm.rulesFunc(item) : [{
          required: false
        }]
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(item.fieldCnName))]), _vm._v(" "), (item.inputType === 'datetimerange') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "datetimerange",
        "range-separator": "~",
        "start-placeholder": _vm.Language('开始日期'),
        "end-placeholder": _vm.Language('结束日期'),
        "value-format": "yyyy-MM-dd HH:mm:ss"
      },
      model: {
        value: (_vm.datetimerangeObj[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.datetimerangeObj, item.fieldName, $$v)
        },
        expression: "datetimerangeObj[item.fieldName]"
      }
    }) : (item.inputType == 'date') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "date",
        "placeholder": _vm.Language('请选择') + item.fieldCnName
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType == 'time') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "time",
        "placeholder": _vm.Language('请选择') + item.fieldCnName
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType == 'datetime' || item.inputType == 'datetime') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "datetime",
        "placeholder": _vm.Language('请选择') + item.fieldCnName
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.fieldName === 'isOverTime' || item.fieldName === 'isWheelOverTime' || item.fieldName === 'isTipsCus' || item.fieldName === 'isReceiveOverTime' ||
      item.fieldName === 'isVisit' || item.fieldName === 'isBeVisit' || item.fieldName === 'isSolved' || item.fieldName === 'isSat') ? _c('el-switch', {
      attrs: {
        "active-value": '1',
        "inactive-value": '0',
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType == 'radio' || item.inputType == 'checkbox') ? _c('RadioCheckBox', {
      ref: item.fieldName,
      refInFor: true,
      attrs: {
        "dataOrigin": item.dataOrigin,
        "inputType": item.inputType,
        "fieldName": item.fieldName,
        "editType": _vm.editType,
        "filterData": _vm.filterData[item.dataOrigin]
      }
    }) : (item.inputType == 'select' || item.inputType == 'personnelSelect' || item.fieldName == 'groupId' || item.fieldName == 'userId') ? _c('SelectList', {
      ref: item.fieldName,
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholderLoad": item.fieldCnName,
        "dataMultiple": item.selectType,
        "dataOrigin": item.dataOrigin,
        "inputType": item.inputType,
        "fieldName": item.fieldName,
        "editType": _vm.editType,
        "orderStatus": _vm.sFormInfo.status,
        "filterData": _vm.filterData[item.dataOrigin]
      },
      on: {
        "orderFormDesignGetListFn": _vm.orderFormDesignGetListFn,
        "changeOrgFn": _vm.changeOrgFn,
        "originTypeChange": _vm.originTypeChange,
        "priorityCodeChange": _vm.priorityCodeChange
      }
    }) : (item.inputType === 'cascader') ? _c('CascaderList', {
      ref: item.fieldName,
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "checkStrictly": item.cascadeType == 1 ? true : false,
        "placeholderLoad": item.fieldCnName,
        "dataOrigin": item.dataOrigin,
        "editType": _vm.editType
      }
    }) : (item.inputType === 'textarea' && (item.fieldName == 'content' || item.fieldName == 'handleContent')) ? _c('div', [_c('el-popover', {
      ref: item.fieldName,
      refInFor: true,
      attrs: {
        "placement": "bottom-start",
        "width": "300",
        "trigger": "click"
      }
    }, [_c('el-tree', {
      attrs: {
        "data": _vm.modelCfgList.filter(function (mItem) {
          if (item.fieldName == 'content') { return mItem.modelType == 1 && mItem.orderTypeCode == _vm.sForm.orderTypeCode }
          else { return mItem.modelType == 2 && mItem.orderTypeCode == _vm.sForm.orderTypeCode }
        }),
        "props": {
          children: 'children',
          label: 'name'
        }
      },
      on: {
        "node-click": function (data, node, obj) { return _vm.handleNodeClick(data, node, obj, item.fieldName); }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "reference",
        "type": "text",
        "size": "mini",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": _vm.orderModelCfgGetListFn
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "iconfont iconny-027xuanzemoban text-middle mr-5"
    }), _vm._v(_vm._s(_vm.Language(item.fieldName == 'content' ? '选择工单登记' : '选择工单回复')) + "\n          ")])], 1), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "textarea",
        "rows": 4,
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    })], 1) : (item.fieldName == 'labMsg') ? _c('div', [(_vm.sessLabPath && _vm.sessLabPath.length) ? _c('div', {
      ref: item.fieldName,
      refInFor: true,
      staticClass: "label-list"
    }, _vm._l((_vm.sessLabPath), function(item, index) {
      return (_vm.editType != 'examine' && _vm.editType != 'info' && _vm.editType != 'return') ? _c('el-tag', {
        key: index,
        attrs: {
          "type": "success",
          "size": "small",
          "closable": ""
        },
        on: {
          "close": function($event) {
            return _vm.removeSessionLab(item, index)
          }
        }
      }, [_vm._v(_vm._s(item.LabPath))]) : _vm._e()
    }), 1) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": function($event) {
          _vm.sessionLabVisible = true
        }
      }
    }, [_vm._v(_vm._s(_vm.Language(_vm.sessLabPath.length ? '继续选择' : '选择标签')))])], 1) : (item.inputType === 'input' && item.fieldCnName == '上传附件') ? _c('div', [_c('div', {
      staticClass: "linkStyle",
      staticStyle: {
        "height": "auto",
        "line-height": "normal"
      }
    }, [_c('el-upload', {
      ref: "uploadFile",
      refInFor: true,
      staticClass: "avatar-uploader",
      attrs: {
        "action": "null",
        "multiple": true,
        "http-request": _vm.handleUploadHttpRequest,
        "before-upload": _vm.handleBeforeUpload,
        "on-change": _vm.handleUploadChange,
        "show-file-list": false,
        "accept": "*",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "type": "text",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      slot: "trigger"
    }, [_vm._v(_vm._s(_vm.Language(_vm.fileList.length ? '继续添加' : '添加附件')))])], 1), _vm._v(" "), (_vm.fileList != null) ? _c('ul', {
      staticClass: "fileList"
    }, _vm._l((_vm.fileList), function(item, index) {
      return _c('li', {
        key: index
      }, [_c('i', {
        staticClass: "iconfont iconlianjie fileIcon"
      }), _vm._v(" "), _c('a', {
        staticStyle: {
          "color": "#409EFF"
        },
        attrs: {
          "type": "primary",
          "href": item.path,
          "download": item.name,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.editType != 'examine' && _vm.editType != 'info' && _vm.editType != 'return') ? _c('i', {
        staticClass: "el-icon-delete-solid fileDel",
        on: {
          "click": function($event) {
            return _vm.fileDeleteFn(index)
          }
        }
      }) : _vm._e()])
    }), 0) : _vm._e()], 1)]) : (item.inputType === 'textarea') ? _c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "textarea",
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType === 'number') ? _c('el-input-number', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "controls-position": "right",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType === 'departmentSelect') ? _c('DepartPersonSelect', {
      ref: item.fieldName,
      refInFor: true,
      attrs: {
        "editType": _vm.editType
      }
    }) : _c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "clearable": "",
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return' || ((item.fieldName == 'vId' || item.fieldName == 'nikeName' || item.fieldName == 'sourceId') && ((_vm.sFormInfo.status && _vm.sFormInfo.status != '0') || _vm.editType == 'hotline'))
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName]"
      }
    })], 1)
  }), _vm._v(" "), (_vm.editType == 'add' || _vm.editType == 'hotline' || (_vm.editType == 'edit' && _vm.sFormInfo['status'] == 0)) ? _c('el-form-item', {
    attrs: {
      "prop": "solveSelf",
      "label": _vm.Language('是否解决')
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0'
    },
    on: {
      "change": _vm.changeCloseFn
    },
    model: {
      value: (_vm.sForm.solveSelf),
      callback: function($$v) {
        _vm.$set(_vm.sForm, "solveSelf", $$v)
      },
      expression: "sForm.solveSelf"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sFormInfo.status != 8 && _vm.editType != 'examine' && _vm.editType != 'info' && _vm.editType != 'return') ? _c('el-row', [_c('el-form-item', [((_vm.editType == 'add' || _vm.sFormInfo['status'] == 0) || (_vm.editType == 'hotline' && !_vm.isHotlineSubmit)) ? _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.submitLoading
    },
    on: {
      "click": function($event) {
        return _vm.saveFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('暂 存')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveFn
    }
  }, [_vm._v(_vm._s(_vm.Language('提 交')))])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    ref: "orderSessionLab",
    staticClass: "orderSessionLab",
    attrs: {
      "title": _vm.Language('会话标签'),
      "width": "60%",
      "visible": _vm.sessionLabVisible,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.sessionLabVisible = $event
      }
    }
  }, [(_vm.sessionLabVisible) ? _c('Sessionlab', {
    attrs: {
      "pageType": "SASS",
      "sessLabPath": _vm.sessLabPath
    },
    on: {
      "submitLabFn": _vm.fetchLablistFn
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7bef738c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/OrderForm.vue
// module id = 1337
// module chunks = 5